import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/app/about/components/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/vitiquest-site/vitiquest-site/src/components/ui/AppImage.tsx");
